import { theme } from 'antd';

import type { ThemeConfig } from 'antd';

export const lightTheme: ThemeConfig = {
  algorithm: [theme.defaultAlgorithm],
  token: {
    colorPrimary: '#fb9318',
    colorText: '#2c2543',
    colorWarning: '#bd363b',
    colorError: '#bd363b',
    colorTextPlaceholder: '#667180',
    fontFamily: 'Lato',
    zIndexPopupBase: 3000,
    zIndexBase: 3000,
  },
  components: {
    Table: {
      borderColor: '#cccad7',
      headerBg: '#f2f2fb',
      fontSize: 14,
      selectionColumnWidth: 10,
    },
    Slider: {
      trackBg: '#fb9318',
      trackHoverBg: '#fb9318',
      handleColor: '#fb9318',
      handleActiveColor: '#fb9318',
    },
  },
};
